import React from 'react';

export const JobInformationPanel = ({ jobData }) => {
  return (
    <div className="info-section">
      <div className="info-row">
        <span className="info-label">Job Number</span>
        <span className="info-value">{jobData?.jobNo || 'N/A'}</span>
      </div>
      <div className="info-row">
        <span className="info-label">Customer</span>
        <span className="info-value">{jobData?.customer || 'N/A'}</span>
      </div>
      <div className="info-row">
        <span className="info-label">Pickup</span>
        <span className="info-value">{jobData?.pickupLocation || 'N/A'}</span>
      </div>
      <div className="info-row">
        <span className="info-label">Delivery</span>
        <span className="info-value">{jobData?.deliveryLocation || 'N/A'}</span>
      </div>
      <div className="info-row">
        <span className="info-label">Status</span>
        <span className="info-value">{jobData?.jobStatus || 'N/A'}</span>
      </div>
      <div className="info-row">
        <span className="info-label">Scheduled</span>
        <span className="info-value">
          {jobData?.scheduledDate ? new Date(jobData.scheduledDate).toLocaleString() : 'N/A'}
        </span>
      </div>
    </div>
  );
};

export const VehicleInformationPanel = ({ vehicleData }) => {
  return (
    <div className="info-section">
      <div className="info-row">
        <span className="info-label">Vehicle No</span>
        <span className="info-value">{vehicleData?.vehicleNo || 'N/A'}</span>
      </div>
      <div className="info-row">
        <span className="info-label">Driver</span>
        <span className="info-value">{vehicleData?.driverName || 'N/A'}</span>
      </div>
      <div className="info-row">
        <span className="info-label">Contact</span>
        <span className="info-value">{vehicleData?.driverMobile || 'N/A'}</span>
      </div>
      <div className='info-row'>
      <span className='info-label'>Speed </span>
      <span className='info-value'>{vehicleData?.speed || 'N/A'}</span>
      </div>
    </div>
  );
};